import { useTranslation } from "react-i18next";
import mayamindLogo from "@/assets/Frame.svg";
import { useAboutContent } from "../../application/hooks/useAboutContent";
import { PageShell } from "@/components/layout/PageShell";

const AboutPage = () => {
  const { t } = useTranslation("about");
  const { content, loading, error } = useAboutContent();

  if (loading) {
    return (
      <PageShell className="flex w-full items-center justify-center">
        <p className="text-sm text-gray-500">{t("loading")}</p>
      </PageShell>
    );
  }

  if (error || !content) {
    return (
      <PageShell className="flex w-full items-center justify-center">
        <p className="text-sm text-red-600">{error ?? t("loadError")}</p>
      </PageShell>
    );
  }

  return (
    <PageShell className="w-full">
      <h1 className="text-xl font-semibold text-gray-900">{content.pageTitle}</h1>

      <div className="mx-auto mt-10 flex max-w-3xl justify-center sm:mt-0">
        <div className="flex h-[130px] w-[130px] items-center justify-center rounded-[28px] border border-gray-200/60 bg-white sm:h-[150px] sm:w-[150px]">
          <img
            src={mayamindLogo}
            alt="Maya-mind"
            className="h-20 w-auto sm:h-24 scale-120"
          />
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-14 pb-20 text-left sm:mt-12 sm:space-y-16">
        {content.sections.map((section, index) => (
          <section key={index} className="space-y-5">
            {section.heading ? (
              <h2 className="text-lg font-bold text-gray-950 sm:text-xl">
                {section.heading}
              </h2>
            ) : index === 0 && content.topicTitle ? (
              <h2 className="text-lg font-bold text-gray-950 sm:text-xl">
                {content.topicTitle}
              </h2>
            ) : null}

            <div className="whitespace-pre-line text-[15px] leading-7 text-gray-800 sm:text-base sm:leading-8">
              {section.content}
            </div>

            {section.emphasis ? (
              <p className="text-[15px] font-bold leading-7 text-gray-950 sm:text-base sm:leading-8">
                {section.emphasis}
              </p>
            ) : null}
          </section>
        ))}
      </div>
    </PageShell>
  );
};

export default AboutPage;
